import { io } from 'socket.io-client'
import { toFullUrl } from '#shared/lib/url/to-full-url'
import { authTokenQueryOptions } from './auth-token-query'
import { queryClient } from './query-client'

declare module 'socket.io-client' {
  interface Socket {
    meta?: {
      initializedAt?: Date
    }
  }
}

const url = toFullUrl(import.meta.env.VITE_WEBSOCKET_URL)

export const wsClient = io(url, {
  auth: async (done: (data: object) => void) => {
    const accessToken = await queryClient.fetchQuery(authTokenQueryOptions)
    done({
      token: accessToken,
    })
  },
})

wsClient.on('connect', () => {
  if (!wsClient.meta) wsClient.meta = {}
  wsClient.meta.initializedAt = new Date()
})
